// モーダル表示中の背面(body)スクロールロックを一元化するヘルパー。CommonsModal 経路
// (useModal の watch)と、自前 isOpen で駆動するモーダル(incomplete-me-modal 等)の
// 両方から呼び、body.modal-open のトグルとスクロールバー幅の補償を一貫させる。
// document を持たない環境(SSR/vitest/storybook)では何もしない。
//
// open=true: body に overflow:hidden が付くとビューポートのスクロールバーが消え、
//   クラシックスクロールバー環境ではビューポート幅が広がりページ内容が横にズレる。
//   ロック前にスクロールバー幅を実測し、その幅ぶんを body の padding-right
//   (--modal-scrollbar-compensation)で補ってから modal-open を付与する
//   (オーバーレイスクロールバー環境では 0=無害)。
// open=false: modal-open を外し、補償 var を除去する。
export const setBodyModalLock = (open: boolean): void => {
  if (!import.meta.client || typeof document === 'undefined') return
  if (open) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
    document.body.style.setProperty(
      '--modal-scrollbar-compensation',
      scrollbarWidth > 0 ? `${scrollbarWidth}px` : '0px'
    )
    document.body.classList.add('modal-open')
  } else {
    document.body.classList.remove('modal-open')
    document.body.style.removeProperty('--modal-scrollbar-compensation')
  }
}
